import React from 'react';
import IconBase from './IconBase';

const AdminStrikethroughIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M18.5,15.8L7.1,4.4l4.3-1.6c0.2-0.1,0.4-0.1,0.6-0.1s0.4,0,0.6,0.1l5.7,2.1C18.7,5,19,5.3,19.2,5.6c0.2,0.3,0.3,0.6,0.3,1v4.5c0,0.8-0.1,1.5-0.2,2.3C19.1,14.2,18.8,15,18.5,15.8z M19.3,21.4l-2.8-2.7c-0.5,0.6-1.1,1.1-1.8,1.5c-0.7,0.4-1.3,0.8-2.1,1.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.4,0s-0.3,0-0.4,0c-0.1,0-0.2,0-0.3-0.1c-2-0.7-3.7-2.1-4.9-4c-1.3-1.9-1.9-4-1.9-6.2V6.6L2.7,4.8C2.5,4.6,2.5,4.4,2.5,4.2c0-0.2,0.1-0.4,0.2-0.5C2.8,3.6,3,3.5,3.2,3.5c0.2,0,0.4,0.1,0.5,0.2l16.6,16.6c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2C19.6,21.6,19.4,21.5,19.3,21.4z"/>
        </IconBase>
    )
}

export default AdminStrikethroughIcon;